import { AfterViewInit, Component, ElementRef, Input, NgZone, OnDestroy, ViewChild } from '@angular/core';
import { Chart, ChartItem, ScriptableContext } from "chart.js";
import { WordCloudController } from "chartjs-chart-wordcloud";
import { COMMON_OPTIONS } from "./configs/word-cloud-chart.component.config";
import { mapDataValuesToPixels, mapDataValueToColor } from "./helpers/word-cloud-chart.component.helper";

@Component({
    selector: 'app-word-cloud-chart',
    templateUrl: './word-cloud-chart.component.html',
    styleUrls: ['./word-cloud-chart.component.scss'],
    standalone: false
})
export class WordCloudChartComponent implements AfterViewInit, OnDestroy {

  @Input()
  set chartLabels(data: string[]) {
    this._chartLabels = data;
    this.createChart();
  };

  @Input()
  set chartData(data: number[]) {
    this._chartData = data;
    this.createChart();
  };

  @ViewChild('canvas', {static: true})
  canvas: ElementRef<HTMLCanvasElement>;

  private _chart: Chart | undefined;

  private _chartLabels: string[];

  private _chartData: number[];

  private readonly maxWordSizeToCanvasRatio: number = 0.15;

  constructor(private ngZone: NgZone) {}

  reRender(): void {
    if (this._chart) {
      this.createChart();
    }
  }

  private createChart(): void {

    if (!this.canvas || !this._chartLabels || !this._chartData) {
      return
    }

    this.destroyChart();

    const canvas = this.canvas.nativeElement;
    const height = this.canvas.nativeElement.clientHeight;
    const context: ChartItem = canvas.getContext('2d');
    const maxAvailableHeight = height * this.maxWordSizeToCanvasRatio;

    if (!context) {
      return;
    }

    this.ngZone.runOutsideAngular(() => {
      this._chart = new Chart(context,
        {
          type: WordCloudController.id,
          data: {
            labels: this._chartLabels,
            datasets: [
              {
                label: '',
                data: mapDataValuesToPixels(this._chartData, maxAvailableHeight),
                color: (ctx: ScriptableContext<'wordCloud'>) => mapDataValueToColor(ctx.raw as number, maxAvailableHeight),
              },
            ],
          },
          options: COMMON_OPTIONS
        }
      )
    });
  }

  ngAfterViewInit(): void {
    if (!this._chart) {
      this.createChart();
    }
  }

  ngOnDestroy(): void {
    this.destroyChart();
  }



  private destroyChart(): void {
    if (this._chart) {
      this._chart.destroy();
      this._chart = null;
    }
  }

}











